import React, { useState } from 'react'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import ErrorBoundary from '@/components/ErrorBoundary'
import { ModalBody } from 'reactstrap'
import { ResultDataEditor } from '@/internal-app/pages/tasks/taskResultData'
import { ValidationBoundary, ValidationState } from '@/components/validation'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import context from '@/context'
import { openDialog } from '@/store/Dialogs'
import { useDispatch } from '@/hooks/dispatch'
import { dialogTypes } from '@/dialogs'

function TaskResultEditorDialog (props) {
  const { task, onAction } = props
  const [data, setData] = useState(task.result)
  const [saving, setSaving] = useState(false)
  const actions = useDispatch({ openDialog })

  function onSaveError () {
    setSaving(false)
    actions.openDialog({ dialogType: dialogTypes.alert, content: 'Common.UnauthorizedAccess' })
  }
  return (
    <ValidationBoundary>
      <BasicHeader title='Tasks.TaskResult' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <ResultDataEditor task={task} data={data} onChange={x => setData({ ...data, ...x })} />
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter
          {...props}
          primaryButtonText='Common.SaveAndClose'
          icon={saving ? 'loader bx-spin' : 'save'}
          disabled={!isValid || saving}
          onAction={() => {
            setSaving(true)
            context.api.taskService.saveResultData({ id: task.id, result: JSON.stringify(data), ignoreNoChanges: true })
              .then(success => {
                if (success) {
                  onAction({ id: task.id, data })
                } else {
                  onSaveError()
                }
              }).catch(onSaveError)
          }} />
      } />
    </ValidationBoundary>
  )
}

export default{
  modalProps: {
    size: 'lg'
  },
  component: TaskResultEditorDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/taskResultEditor.js